import { useMemo } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import { useWorkstationStore } from '@/modules/Workstation/store'
import { ROUTES } from '../routes'

export const useControllerNavigation = () => {
    const location = useLocation()
    const navigate = useNavigate()
    const { workstation } = useWorkstationStore()

    const backCallback = useMemo(() => {
        if ([ROUTES.VEHICLE_ALLOCATION, ROUTES.DISRUPTIONS, ROUTES.CONTROL_SHEET].includes(location.pathname)) {
            return () => navigate(ROUTES.HOME)
        }

        if (location.pathname === ROUTES.SHARED_LOG) {
            return () => navigate(ROUTES.HOME)
        }
    }, [location, navigate])

    const paths = useMemo(() => {
        if (workstation && location.pathname === ROUTES.VEHICLE_ALLOCATION) {
            return [workstation.workstationNumber, 'Vehicle allocation']
        }

        if (workstation && location.pathname === ROUTES.DISRUPTIONS) {
            return [workstation.workstationNumber, 'Disruptions']
        }

        if (workstation && location.pathname === ROUTES.SHARED_LOG) {
            return ['Controller logs', workstation.workstationNumber]
        }

        if (workstation && location.pathname === ROUTES.CONTROL_SHEET) {
            return [workstation.workstationNumber, 'Control sheet']
        }

        return []
    }, [workstation, location])

    return {
        backCallback,
        paths,
    }
}
